module.exports = __webpack_public_path__ + "img/13.d3908c36.jpg";